import { makeConsentSelector, makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { type AppState, type GenericMap } from "@client/types";
import { connect } from "react-redux";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {
  onChange: (consent: GenericMap<any>) => void;
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const consentSelector = makeConsentSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);
    const consent = consentSelector(state, {
      id: props.id,
      source: props.source,
      consentFieldIds: localState.consentFieldIds
    });
    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      consent,
      isVisible: !!consent
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onChange: props.onChange
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
